import { render, staticRenderFns } from "./ConstructionTaskListPage.vue?vue&type=template&id=315eba4c&"
import script from "./ConstructionTaskListPage.vue?vue&type=script&lang=ts&"
export * from "./ConstructionTaskListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports